import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { Footer, Header, UikContainerVertical } from 'components'
import cls from './Authenticated.module.scss'

const Authenticated = ({ children, showHeader, showFooter }) => (
  <div className="flex flex-col">
    {showHeader && <Header />}
    <UikContainerVertical
      className={classnames('relative', cls.dashboardMenuAnimate, cls.dashboardMinHeight)}
    >
      {children}
    </UikContainerVertical>
    {showFooter && <Footer />}
  </div>
)

Authenticated.propTypes = {
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
}
Authenticated.defaultProps = {
  showHeader: true,
  showFooter: true,
}

export default Authenticated
